<template>
  <keep-alive :include="tagsList">
    <router-view :key="key" />
  </keep-alive>
</template>

<script>
import bus from "../../util/bus";
export default {
  data () {
    return {
      tagsList: []

    };
  },
  computed: {
    key () {
      return this.$route.fullPath
    }
  },
  mounted () {
    // 只有在标签页列表里的页面才使用keep-alive，即关闭标签之后就不保存到内存中了。
    bus.$on("tags", (msg) => {
      let arr = [];
      for (let i = 0, len = msg.length; i < len; i++) {
        msg[i].name && arr.push(msg[i].name);
      }
      this.tagsList = arr;
    });
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/common/Layout.vue